module.exports = __webpack_public_path__ + "img/gruppofma.20f3b0e2.png";